module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_c('b', [_vm._v("J. L. Woodson")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("Emma Vidal “Grandma Goose”")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("Grandma Jean")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("Dearest and Sandy")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_c('b', [_vm._v("Martha Kennerson")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_vm._v("I’d like to dedicate this book to my writing tribe. Your love and support continues to lift me up. I love and appreciate you all.")]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_c('b', [_vm._v("Naleighna Kai")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width dedication-content"
  }, [_c('i', [_vm._v("I dedicate this book to Jean Woodson, Eric Harold Spears, LaKecia Janise Woodson, Mildred E. Williams, Anthony Johnson, L. A. Banks, Octavia Butler, Tanishia Pearson Jones, Emmanuel Donnell McDavid, and Priscilla Jackson.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5acbfb0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 69
// module chunks = 0